<template>
    <div>
        <router-link :to="{name: 'app.cart'}" class="btn btn-sm icon icon-light">
            <i class="fas fa-cart-arrow-down"></i>
        </router-link>
        <span v-if="quantity > 0"
              class="wos__quantity-badge badge badge-pill badge-primary strong">{{quantity}}</span>
    </div>
</template>

<script>
    import {EVENT_CART_COUNT_UPDATE} from "../../core/constants";

    export default {
        name: "CartIcon",

        created() {
            this.$eventBus.$on(EVENT_CART_COUNT_UPDATE, quantity => {
                this.$store.dispatch('cartStore/updateCount', quantity);
            });
        },

        computed: {
            quantity() {
                return this.$store.getters['cartStore/countItems'];
            }
        }
    }
</script>

<style scoped>

</style>
